var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fab-editor" }, [
    _c(
      "div",
      { staticClass: "options" },
      _vm._l(_vm.fabs, function (fab, i) {
        return _c("FabItem", {
          key: fab.type + i,
          attrs: { value: fab, "icon-enabled": _vm.fabIconActive },
          on: {
            input: function (f) {
              return _vm.updateFabItem(f, i)
            },
          },
        })
      }),
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "preview" }, [_c("FabPreview")], 1),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }